<template>
  <section class="select-account">
    <label :style="labelCssProps">{{ label }}</label>
    <Select
      :styleConfig="styleConfig.label"
      :placeholder="this.$t('common.selectAccount')"
      :options="options"
      @input="onInput"
      :value="value"
    />
  </section>
</template>

<script>
import Select from '@/components/interact/Select.vue';

const styleDefaultConfig = {
  label: {
    fontSize: '20px',
    color: '#000d28',
    fontFamily: 'Oblivian'
    // fontFamily: 'NotoSansCJKsc-Medium'
  }
};

export default {
  name: 'SelectAccount',
  components: {
    Select
  },
  props: {
    styleConfig: {
      type: Object,
      default() {
        return styleDefaultConfig;
      }
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: []
    },
    value: ''
  },
  computed: {
    labelCssProps() {
      const style = this.styleConfig.label;
      return {
        '--color': style.color,
        '--fontSize': style.fontSize,
        '--fontFamily': style.fontFamily
      };
    }
  },
  watch: {
    value(val) {
      // watch it
      console.log('Prop changed: ', val);
    }
  },
  methods: {
    onInput(value) {
      this.$emit('change', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.select-account {
  & > label {
    font-size: var(--fontSize, 21px);
    color: var(--color, #000d28);
    font-family: var(--fontFamily, NotoSansCJKsc-Medium);
  }
}
</style>
